import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OverlayModule } from '@Common/Overlay/overlay.module';

import { DndModule } from 'ngx-drag-drop';
import { Gridster, GridsterItem } from 'angular-gridster2';
import { SelectModule } from 'primeng/select';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { BlockComponent } from './components/Block/block.component';
import { PageBuilderComponent } from './components/PageBuilder/page-builder.component';
import { BlockAdderComponent } from './components/BlockAdder/block-adder.component';
import { TwigRendererComponent } from './components/TwigRenderer/twig-renderer.component';
import { BlockFormComponent } from './components/BlockForm/block-form.component';
import { LocalizationModule } from '../../Core/Localization/localization.module';
import { TextFieldComponent } from './components/FormFields/TextField/text-field.component';
import { FileUploadFieldComponent } from './components/FormFields/FileUploadField/file-upload-field.component';
import { DropdownFieldComponent } from './components/FormFields/DropdownField/dropdown-field.component';
import { ImageUploadFieldComponent } from './components/FormFields/ImageUploadField/image-upload-field.component';
import { ImagesService } from './services/images.service';
import { ImagesApi } from '../../api/images/images.api';
import { BlockWrapperComponent } from './components/BlockWrapper/block-wrapper.component';
import { NumberFieldComponent } from './components/FormFields/NumberField/number-field.component';
import { CheckboxesFieldComponent } from './components/FormFields/CheckboxesField/checkboxes-field.component';
import { ColorPickerFieldComponent } from './components/FormFields/ColorPickerField/color-picker-field.component';
import { ChartColorPickerFieldComponent } from './components/FormFields/ChartColorPickerField/chart-color-picker-field.component';
import { ColorPickerByCountFieldComponent } from './components/FormFields/ColorPickerByCountField/color-picker-by-count-field.component';
import { MiscModule } from '../../Common/Misc/misc.module';
import { CommonFormsModule } from '../../Common/Forms/forms.module';
import { StaticTextFieldComponent } from './components/FormFields/StaticTextField/static-text-field.component';
import { CheckboxFieldComponent } from './components/FormFields/CheckboxField/checkbox-field.component';
import { PanelFieldComponent } from './components/FormFields/PanelField/panel-field.component';

import { CommonBasicModule } from '../Basic/basic.module';
import { RichTextBlockComponent } from './components/RichTextBlock/rich-text-block.component';

import { LayoutModule } from '../Layout/layout.module';
import { TextStyleFieldComponent } from './components/TextStyleField/text-style-field.component';
import { DividerStyleFieldComponent } from './components/FormFields/DividerField/divider-style-field.component';
import { TwigRendererService } from './services/twig-renderer.service';
import { ColorCheckboxesFieldComponent } from './components/FormFields/ColorCheckboxesField/color-checkboxes-field.component';
import { ChartColorCheckboxesFieldComponent } from './components/FormFields/ChartColorCheckboxesField/chart-color-checkboxes-field.component';
import { StaticTextHeadingFieldComponent } from './components/FormFields/StaticTextHeadingField/static-text-heading-field.component';
import { ImageSettingsFieldComponent } from './components/FormFields/ImageSettingsField/image-settings-field.component';
import { ImageEffectsFieldComponent } from './components/FormFields/ImageEffectsField/image-effects-field.component';
import { ImageStyleFieldComponent } from './components/FormFields/ImageStyleField/image-style-field.component';
import { LinkFieldComponent } from './components/FormFields/LinkField/link-field.component';
import { ButtonStyleFieldComponent } from './components/FormFields/ButtonStyleField/button-style-field.component';
import { MediaServiceApi } from '../../api/mediaService/media-service.api';
import { ClickOutsideService } from './services/click-outside.service';
import { RadioButtonsFieldComponent } from './components/FormFields/RadioButtonsField/radio-buttons-field.component';
import { FilterModule } from '../Filter/filter.module';
import { FilterFieldComponent } from './components/FormFields/FilterField/filter-field.component';
import { BlockPaddingComponent } from './components/FormFields/block-padding/block-padding.component';
import {
    MediaTypeColorPickerWrapperFieldComponent
} from './components/FormFields/MediaTypeColorPickerWrapperField/media-type-color-picker-wrapper-field.component';
import { LinksListFieldComponent } from './components/FormFields/LinksListField/links-list-field.component';
import { LinksStyleFieldComponent } from './components/FormFields/LinksStyleField/links-style-field.component';
import { PlainTextService } from './services/plain-text.service';
import { ConditionalTextHeadingFieldComponent } from './components/FormFields/ConditionalTextHeadingField/conditional-text-heading-field.component';
import {
    OptionalMediaTypeColorPickerFieldComponent
} from './components/FormFields/OptionalMediaTypeColorPickerField/optional-media-type-color-picker-field.component';
import { LayoutBlockComponent } from './components/LayoutBlock/layout-block.component';
import { LayoutBlockAdderComponent } from './components/LayoutBlockAdder/layout-block-adder.component';
import { LayoutStyleFieldComponent } from './components/FormFields/LayoutStyleField/layout-style-field.component';


import { ContentLibraryPanelFieldComponent } from './components/FormFields/ContentLibraryPanelField/content-library-panel.component';
import { MultiContentLibraryPanelFieldComponent } from './components/FormFields/MultiContentLibraryPanelField/multi-content-library-panel.component';
import { ChartFieldComponent } from './components/FormFields/ChartField/chart-field.component';
import { BriefingChartDimensionsFieldComponent } from './components/FormFields/BriefingChartDimensionsField/briefing-chart-dimensions-field.component';
import { BriefingChartSettingsFieldComponent } from './components/FormFields/ImageSettingsField/briefing-chart-settings-field.component';
import { CuratorBlockComponent } from './components/CuratorBlock/curator-block.component';
import { CuratorStyleFieldComponent } from './components/FormFields/CuratorStyleField/curator-style-field.component';
import { BooleanRadioFieldComponent } from './components/FormFields/BooleanRadioField/boolean-radio-field.component';
import { CornerRadiusComponent } from './components/FormFields/CornerRadius/corner-radius.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ButtonModule,
        SelectModule,
        LocalizationModule,
        Gridster,
        GridsterItem,
        TooltipModule,
        MiscModule,
        CommonFormsModule,
        CommonBasicModule,
        LayoutModule,
        DndModule,
        FilterModule,
        ReactiveFormsModule,
        MiscModule,
        OverlayModule
    ],
    declarations: [
        BlockWrapperComponent,
        BlockComponent,
        BlockAdderComponent,
        TwigRendererComponent,
        BlockFormComponent,
        TextFieldComponent,
        NumberFieldComponent,
        FileUploadFieldComponent,
        ImageUploadFieldComponent,
        DropdownFieldComponent,
        PageBuilderComponent,
        CheckboxesFieldComponent,
        CheckboxFieldComponent,
        ColorPickerFieldComponent,
        ChartColorPickerFieldComponent,
        MediaTypeColorPickerWrapperFieldComponent,
        ColorPickerByCountFieldComponent,
        ContentLibraryPanelFieldComponent,
        MultiContentLibraryPanelFieldComponent,
        StaticTextFieldComponent,
        PanelFieldComponent,
        RichTextBlockComponent,
        TextStyleFieldComponent,
        DividerStyleFieldComponent,
        ColorCheckboxesFieldComponent,
        ChartColorCheckboxesFieldComponent,
        StaticTextHeadingFieldComponent,
        ConditionalTextHeadingFieldComponent,
        ImageSettingsFieldComponent,
        ImageEffectsFieldComponent,
        ImageStyleFieldComponent,
        ButtonStyleFieldComponent,
        LinkFieldComponent,
        RadioButtonsFieldComponent,
        FilterFieldComponent,
        BlockPaddingComponent,
        CornerRadiusComponent,
        LinksListFieldComponent,
        LinksStyleFieldComponent,
        OptionalMediaTypeColorPickerFieldComponent,
        LayoutBlockComponent,
        LayoutBlockAdderComponent,
        LayoutStyleFieldComponent,
        ChartFieldComponent,
        BriefingChartDimensionsFieldComponent,
        BriefingChartSettingsFieldComponent,
        CuratorBlockComponent,
        CuratorStyleFieldComponent,
        BooleanRadioFieldComponent
    ],
    exports: [
        BlockWrapperComponent,
        BlockComponent,
        BlockAdderComponent,
        TwigRendererComponent,
        BlockFormComponent,
        TextFieldComponent,
        NumberFieldComponent,
        FileUploadFieldComponent,
        ImageUploadFieldComponent,
        DropdownFieldComponent,
        PageBuilderComponent,
        CheckboxesFieldComponent,
        CheckboxFieldComponent,
        ColorPickerFieldComponent,
        ChartColorPickerFieldComponent,
        MediaTypeColorPickerWrapperFieldComponent,
        ColorPickerByCountFieldComponent,
        ContentLibraryPanelFieldComponent,
        StaticTextFieldComponent,
        PanelFieldComponent,
        RichTextBlockComponent,
        TextStyleFieldComponent,
        DividerStyleFieldComponent,
        ColorCheckboxesFieldComponent,
        ChartColorCheckboxesFieldComponent,
        StaticTextHeadingFieldComponent,
        ConditionalTextHeadingFieldComponent,
        ImageSettingsFieldComponent,
        ImageEffectsFieldComponent,
        ImageStyleFieldComponent,
        ButtonStyleFieldComponent,
        LinkFieldComponent,
        RadioButtonsFieldComponent,
        FilterFieldComponent,
        BlockPaddingComponent,
        CornerRadiusComponent,
        LinksStyleFieldComponent,
        OptionalMediaTypeColorPickerFieldComponent,
        LayoutBlockComponent,
        LayoutBlockAdderComponent,
        LayoutStyleFieldComponent,
        ChartFieldComponent,
        BriefingChartDimensionsFieldComponent,
        BriefingChartSettingsFieldComponent,
        CuratorBlockComponent,
        CuratorStyleFieldComponent,
        BooleanRadioFieldComponent,
        MultiContentLibraryPanelFieldComponent
    ],
    providers: [
        ImagesService,
        ImagesApi,
        TwigRendererService,
        MediaServiceApi,
        ClickOutsideService,
        PlainTextService,
    ]
})
export class PageBuilderModule { }
